import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion"; // Import Framer Motion

const projects = [
  {
    title: "Modern Residential Complex",
    category: "Residential Building",
    description: "Luxury apartments with modern amenities and sustainable design",
    image:
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    details: [
      "/assets/R1-min.jpg",
      "/assets/R2-min.jpg",
      "/assets/R3-min.jpg",
      "/assets/R4-min.jpg",
      "/assets/R5-min.jpg",
      "/assets/R6-min.jpg",
      "/assets/R7-min.jpg",
      "/assets/R8-min.jpg",
      "/assets/R9-min.jpg",
      "/assets/R10-min.jpg",
      "/assets/R11-min.jpg",
      "/assets/R12.jpg",
      "/assets/R13-min.jpg",
      "/assets/R14.jpg",
      "/assets/R17-min.jpg",
      "/assets/R18-min.jpg",
      "/assets/R19-min.jpg",
      "/assets/R20-min.jpg",
    ],
  },
  {
    title: "Commercial Plaza",
    category: "Commercial Building",
    description: "State-of-the-art commercial space with premium facilities",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    details: [
      "/assets/C1-min.jpg",
      "/assets/C2-min.jpg",
      "/assets/C3-min.jpg",
      "/assets/C4-min.jpg",
      "/assets/C5-min.jpg",
      "/assets/C6-min.jpg",
      "/assets/C7-min.jpg",
      "/assets/C8-min.jpg",
      "/assets/C12-min.jpg",
      "/assets/C13-min.jpg",
      "/assets/C14-min.jpg",
      "/assets/C15-min.jpg",
      "/assets/C19.jpg",
      "/assets/C20.jpg",
      "/assets/C21.jpg",
      "/assets/C22.jpg",
      "/assets/C23.jpg",
      "/assets/C24.jpg",
      "/assets/C25.jpg",
    ],
  },
  {
    title: "Industrial Facility",
    category: "Industrial Construction",
    description: "Modern industrial complex with advanced infrastructure",
    image:
      "https://images.unsplash.com/photo-1513828583688-c52646db42da?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    details: ["/assets/I1-min.jpg", "/assets/I2.jpg", "/assets/I3.jpg", "/assets/I5.jpg", "/assets/I6.jpg"],
  },
];

const ProjectDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const project = projects[parseInt(id)];

  if (!project) {
    return <p>Project not found!</p>;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      className="min-h-screen bg-gray-50 py-12 px-4"
    >
      <motion.button
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.5 }}
        className="mb-6 inline-flex items-center text-blue-500 hover:text-blue-700"
        onClick={() => navigate(-1)}
      >
        <ArrowLeft className="mr-2" /> Back to Projects
      </motion.button>
      <motion.h1
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.7 }}
        className="text-4xl font-bold text-gray-900 mb-4"
      >
        {project.title}
      </motion.h1>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        className="text-lg text-gray-600 mb-8"
      >
        {project.description}
      </motion.p>
      <motion.div
        className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4"
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0 },
          visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2 },
          },
        }}
      >
        {project.details.map((image, index) => (
          <motion.div
            key={index}
            variants={{
              hidden: { opacity: 0, scale: 0.9 },
              visible: { opacity: 1, scale: 1 },
            }}
            className="rounded-2xl overflow-hidden shadow-lg group"
          >
            <img
              src={image}
              alt={`Detail ${index + 1}`}
              className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
            />
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default ProjectDetails;
